
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host{
  display:block;
}

.listing-header {
  position:relative;
  margin-top:0.5rem;
  display:flex;
  align-items:flex-start;
  justify-content:space-between;
}

.listing-header::after {
  position:absolute;
}

.listing-header::after {
  top:50%;
}

.listing-header::after {
  width:100%;
}

.listing-header::after {
  border-width:0px;
}

.listing-header::after {
  border-bottom-width:1px;
}

.listing-header::after {
  border-style:solid;
}

.listing-header::after {
  border-color:var(--neutral-gray-3);
}

.listing-header::after{

    content:'';
  }

.listing-header ghs-icon {
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration:150ms;
}

.listing-header ghs-icon {
  transition-duration:300ms;
}

.listing-header .title {
  z-index:10;
}

.listing-header .title {
  box-sizing:border-box;
}

.listing-header .title {
  display:flex;
}

.listing-header .title {
  height:4rem;
}

.listing-header .title {
  width:4rem;
}

.listing-header .title {
  align-items:center;
}

.listing-header .title {
  justify-content:center;
}

.listing-header .title {
  border-radius:9999px;
}

.listing-header .title {
  background-color:var(--primary-green);
}

.listing-header .title {
  font-size:var(--fs-2xl);
  line-height:var(--lh-2xl);
}

.listing-header .title {
  font-weight:var(--fw-medium);
}

.listing-header .title {
  color:var(--neutral-white);
}

@media (min-width: 768px){
    .listing-header .title {
    font-size:var(--fs-3xl);
    line-height:var(--lh-3xl);
  }
    .listing-header .title{

      height:75px;
      width:75px;
    }
  }

.listing-header .back-to-top {
  margin-top:-0.5rem;
}

.listing-header .back-to-top {
  display:flex;
}

.listing-header .back-to-top {
  align-items:center;
}

.listing-header .back-to-top {
  gap:0.5rem;
}

.listing-header .back-to-top {
  color:var(--primary-blue-light-2);
}

.listing-header .back-to-top {
  text-decoration-line:none;
}

@media (min-width: 768px) {

  .listing-header .back-to-top {
    gap:1rem;
  }
}

.listing-header .back-to-top:hover, .listing-header .back-to-top:focus {
  cursor:pointer;
}

.listing-header .back-to-top:hover, .listing-header .back-to-top:focus {
  text-decoration-line:underline;
}

.listing-header .back-to-top:hover ghs-icon, .listing-header .back-to-top:focus ghs-icon{
        transform:translateY(-40%);
      }

:host([site='BH']) .listing-header .title {
  background-color:var(--bh-brand-primary-dark);
}

:host([site='BH']) .listing-header .title {
  font-family:var(--bh-ff-body);
}

:host([site='BH']) .listing-header .title {
  font-size:var(--bh-fs-heading-05);
  line-height:var(--bh-lh-heading-05);
  letter-spacing:var(--bh-ls-heading-05);
}

:host([site='BH']) .listing-header .title {
  font-weight:var(--fw-light);
}

:host([site='BH']) .listing-header .back-to-top {
  color:var(--bh-brand-primary-default-compatibility);
}
`;